import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../store';
import { HYDRATE } from 'next-redux-wrapper';
import { ShopSearchUrlParam } from '@/types';

// Define a type for the slice state
export interface ShopSearchState {
  urlParam: (ShopSearchUrlParam & { st?: string }) | null;
}

// Define the initial state using that type
const initialState: ShopSearchState = {
  urlParam: null,
};

export const shopSearchSlice = createSlice({
  name: 'shopSearch',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setShopSearchUrlParam: (
      state,
      action: PayloadAction<ShopSearchUrlParam & { st?: string }>,
    ) => {
      state.urlParam = action.payload;
    },
  },
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.shopSearch,
      };
    },
  },
});

export const { setShopSearchUrlParam } = shopSearchSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectShopSearchUrlParam = (state: RootState) =>
  state.shopSearch.urlParam;

export default shopSearchSlice;
